// id strings for messages/pricing.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const pricing: Dict = {
  "pricing.promo": "Bulan pertamamu mulai {price}",
  "pricing.title": "Bikin cover dengan suara apa pun",
  "pricing.subtitle":
    "Cover tanpa batas, download, dan semua 93.000+ suara. Bisa dibatalkan kapan saja.",
  "pricing.trialLinkInvalid":
    "Link uji coba gratis ini untuk akun lain atau sudah kedaluwarsa — yang ditampilkan checkout biasa.",

  "pricing.basic.subtitle": "Untuk bikin cover",
  "pricing.creator.subtitle": "Untuk video dan suaramu sendiri",
  "pricing.power.subtitle": "Untuk pemakaian berat dan developer",
  "pricing.badge.popular": "Paling populer",

  "pricing.feature.unlimitedCovers": "Cover tanpa batas",
  "pricing.feature.download": "Download cover, vokal, dan musik",
  "pricing.feature.library": "Semua pustaka suara",
  "pricing.feature.tts": "Teks ke suara",
  "pricing.feature.duets": "Duet",
  "pricing.feature.credits": "Kredit tidak pernah kedaluwarsa",
  "pricing.feature.train": "Latih suara tanpa batas",
  "pricing.feature.videos": "Video siap dibagikan: Marble Run dan lirik",
  "pricing.feature.coins50": "50 koin video setiap bulan",
  "pricing.feature.priority": "Pemrosesan prioritas, 250 per 12 jam",
  "pricing.feature.coinsUnlimited": "Koin video tanpa batas",
  "pricing.feature.api": "Kredit API $25 setiap bulan",

  "pricing.compareAll": "Bandingkan semuanya",
  "pricing.trust.cancel": "Batalkan kapan saja, hasil karyamu tetap milikmu",
  "pricing.trust.stripe": "Checkout aman dengan Stripe",
  "pricing.trust.currency": "Harga dalam mata uangmu",

  "pricing.compare.title": "Bandingkan paket",
  "pricing.compare.noPlan": "Tanpa paket",
  "pricing.compare.browse": "Jelajahi dan dengarkan semua suara",
  "pricing.compare.covers": "Cover",
  "pricing.compare.downloads": "Download",
  "pricing.compare.ttsDuets": "Teks ke suara dan duet",
  "pricing.compare.song": "Buat lagu dengan AI",
  "pricing.compare.train": "Latih suaramu sendiri",
  "pricing.compare.videos": "Video (Marble Run, lirik)",
  "pricing.compare.priority": "Pemrosesan prioritas",
  "pricing.compare.api": "Kredit API",
  "pricing.compare.unlimited": "Tanpa batas",
  "pricing.compare.coins50": "50 koin per bulan",
  "pricing.compare.priorityLimit": "250 per 12 jam",
  "pricing.compare.apiAmount": "$25 per bulan",

  "pricing.faq.title": "Pertanyaan",
  "pricing.faq.noPlan.q": "Apa yang bisa aku lakukan tanpa paket?",
  "pricing.faq.noPlan.a":
    "Kamu bisa menjelajahi dan mendengarkan semua suara di Jammable. Bikin cover, download, teks ke suara, dan duet butuh paket.",
  "pricing.faq.basic.q": "Apa saja yang ada di paket Basic?",
  "pricing.faq.basic.a":
    "Paket Basic mencakup cover tanpa batas, download, akses ke seluruh pustaka suara Jammable, teks ke suara, duet, dan kredit yang tidak pernah kedaluwarsa.",
  "pricing.faq.creator.q": "Apa bedanya paket Creator dengan Basic?",
  "pricing.faq.creator.a":
    "Paket Creator berisi semua yang ada di Basic, ditambah latih suara tanpa batas, bikin video siap dibagikan, dan 50 koin Marble Run per bulan.",
  "pricing.faq.power.q": "Apa istimewanya paket Power?",
  "pricing.faq.power.a":
    "Power berisi semua yang ada di Creator, ditambah pemrosesan prioritas (250/12 jam), koin Marble Run tanpa batas, dan kredit API $25 setiap bulan untuk kreator profesional.",
  "pricing.faq.cancel.q": "Apakah langganan bisa dibatalkan kapan saja?",
  "pricing.faq.cancel.a":
    "Bisa, batalkan kapan saja. Semua manfaatmu tetap aktif sampai akhir periode tagihan.",
  "pricing.faq.change.q": "Bisa upgrade atau downgrade?",
  "pricing.faq.change.a":
    "Tentu. Upgrade atau downgrade kapan pun kamu mau, dan manfaatmu akan menyesuaikan.",

  // components/pricing/PricingCard.js
  "pricing.card.perYear": "per tahun, sekitar {price} per bulan",
  "pricing.card.firstMonthThen": "bulan pertama, lalu {price} per bulan",
  "pricing.card.perMonth": "per bulan",
  "pricing.card.startFor": "Mulai dengan {price}",
  "pricing.card.everythingIn": "Semua yang ada di {plan}, plus",
  "pricing.cta.get": "Ambil {plan}",
  "pricing.cta.yourPlan": "Paketmu",
  "pricing.cta.manage": "Kelola paket",
  "pricing.cta.upgradeTo": "Upgrade ke {plan}",
  "pricing.cta.updated": "Langgananmu sudah diperbarui!",
  "pricing.error.generic": "Ada yang salah. Silakan hubungi tim dukungan!",
  "pricing.seo.title": "Harga | Jammable",
  "pricing.seo.description":
    "Paket Jammable untuk bikin cover AI dengan suara apa pun: cover tanpa batas, download, dan 93.000+ suara. Harga dalam mata uangmu, bisa dibatalkan kapan saja.",
};

export default pricing;
